import BaseComponent from '../base/baseComponent';
import micromodalInstance from '../libs/micromodalInstance';
export default class NotifymeForm extends BaseComponent {
    constructor(element) {
        super(element);
        this.emailIsValid = false;
        this.timeToClose = 5000;
        this.handleSubmit();
        this.handlePrivacyChange();
        this.handleEmailChange();
    }
    get SELECTORS() {
        return {
            form: '.form-content',
            submitBtn: '.notifyme-submit',
            privacy: '#notifyMePrivacy',
            email: '#userEmail',
            invalidFeedback: '.privacy-error',
        };
    }
    get CLASSES() {
        return {
            loading: 'loading',
            invalid: 'is-invalid',
            visible: 'visible',
        };
    }
    handleSubmit() {
        this._el.addEventListener('submit', (e) => {
            e.preventDefault();
            let checkboxPrivacy = this._el.querySelector(this.SELECTORS.privacy);
            if (checkboxPrivacy) {
                this.setErrors(false);
                if (!checkboxPrivacy.checked) {
                    this.setErrors(true);
                }
            }
            if (!this.emailIsValid) {
                let emailInput = this._el.querySelector(this.SELECTORS.email);
                emailInput.parentElement.classList.add(this.CLASSES.invalid);
                emailInput.setAttribute('aria-invalid', 'true');
                emailInput.parentElement.querySelector('.invalid--feedback').classList.add(this.CLASSES.visible);
            }
            if (!this.emailIsValid || !checkboxPrivacy.checked) {
                return;
            }
            this.manageData();
        });
    }
    handleEmailChange() {
        let emailInput = this._el.querySelector(this.SELECTORS.email);
        emailInput.addEventListener('blur', (e) => {
            if (/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(emailInput.value) && emailInput.value !== '') {
                emailInput.parentElement.classList.remove(this.CLASSES.invalid);
                emailInput.removeAttribute('aria-invalid');
                emailInput.parentElement.querySelector('.invalid--feedback').classList.remove(this.CLASSES.visible);
                this.emailIsValid = true;
            }
            else {
                emailInput.parentElement.classList.add(this.CLASSES.invalid);
                emailInput.setAttribute('aria-invalid', 'true');
                emailInput.parentElement.querySelector('.invalid--feedback').classList.add(this.CLASSES.visible);
                this.emailIsValid = false;
            }
        });
    }
    handlePrivacyChange() {
        let checkboxPrivacy = this._el.querySelector(this.SELECTORS.privacy);
        checkboxPrivacy.addEventListener('change', (e) => {
            if (!e.currentTarget.checked) {
                this.setErrors(true);
            }
            else {
                this.setErrors(false);
            }
        });
    }
    setErrors(isError) {
        let checkboxPrivacy = this._el.querySelector(this.SELECTORS.privacy);
        let privacyError = this._el.querySelector(this.SELECTORS.invalidFeedback);
        if (checkboxPrivacy) {
            let checkboxParent = checkboxPrivacy.closest('.checkbox');
            if (isError) {
                checkboxParent.classList.add(this.CLASSES.invalid);
                checkboxPrivacy.setAttribute('aria-invalid', 'true');
                privacyError.classList.add(this.CLASSES.visible);
            }
            else {
                checkboxPrivacy.removeAttribute('aria-invalid');
                checkboxParent.classList.remove(this.CLASSES.invalid);
                privacyError.classList.remove(this.CLASSES.visible);
            }
        }
    }
    async manageData() {
        const submitBtn = this._el.querySelector(this.SELECTORS.submitBtn);
        try {
            submitBtn.classList.add(this.CLASSES.loading);
            let response = await this.sendData();
            submitBtn.classList.remove(this.CLASSES.loading);
            this.setFeedbackMessage(response.success);
        }
        catch (ev) {
            console.error(ev);
            submitBtn.classList.remove(this.CLASSES.loading);
        }
    }
    setFeedbackMessage(isSuccess) {
        let message = isSuccess ? this._options['feedback.success'] : this._options['feedback.error'];
        let feedbackIcon = `
        <svg class="icon--${isSuccess ? 'valid' : 'error'}  icon--m no-stroke">
          <use href="#sprite-${isSuccess ? 'valid' : 'error'}"></use>
        </svg>
    `;
        let modalContent = this._el.closest('.notifyme-content');
        modalContent.style.display = 'none';
        let modalFeedback = modalContent.closest('.modal--micromodal-dialog').querySelector('.modal-feedback');
        modalFeedback.querySelector('.feedback-message').innerHTML = message;
        modalFeedback.querySelector('.icon-container').innerHTML = feedbackIcon;
        modalFeedback.removeAttribute('style');
        setTimeout(() => {
            modalFeedback.style.display = 'none';
            modalFeedback.querySelector('.feedback-message').innerHTML = '';
            modalFeedback.querySelector('.icon-container').innerHTML = '';
            modalContent.removeAttribute('style');
            micromodalInstance.forceClose('modal-notifyme');
        }, 3500);
    }
    async sendData() {
        const formData = new FormData(this._el.querySelector(this.SELECTORS.form));
        return await fetch(this._options.endpoint, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (response) {
            return response.json();
        });
    }
}
